import {ObjectUtil} from '../../util/object-util';

export class RiskLocation {
  riskLocationId: string = null;
  description: string = null;
  street: string = null;
  houseNumber: string = null;
  postalCode: string = null;
  location: string = null;
  countryCode: string = null;
  countryName: string = null;
  geoLocationLat: number = null;
  geoLocationLng: number = null;
  skenBuildingValue14: number = null;
  skenTotalValueEur: number = null;
  skenRegionalizedTotalValueM: number = null;
  skenRegionalizedTotalValueEur: number = null;

  public constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
